function getIdeasApiURL() {
  return process.env.GATSBY_IDEAS_API_URL || "";
}

export default getIdeasApiURL;
